
import React, { useState, useEffect, useRef } from "react";
import AdSense from 'react-adsense';
import axios from 'axios';
import { Outlet, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import { useLocation } from 'react-router-dom';
import { FaCaretDown } from 'react-icons/fa';
import { ClipLoader, PulseLoader } from 'react-spinners';
import { isMobile } from 'react-device-detect';
import Cheotele from '../../sub4sub/cheotele.jsx';
import CryptoJS from "crypto-js";
function Jop() {
    const location = useLocation();
    const currentPath = location.pathname;
    const isFirstRender = useRef(true);
    const [datajoptiktok, setDatajoptiktok] = useState('');
    const [showadskeeper, setadskeeper] = useState(false);
    const [datamoney, setdatamoney] = useState([]);
    const [chuadangnhap, setchuadangnhap] = useState(false);
    let eventFired = false;
    const [api_key, setapi_key] = useState('');
    const [idtiktokjop, setidtiktokjop] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isDivVisible, setIsDivVisible] = useState(true);
    const [danhap, setdanhap] = useState(false);
    const handleToggle = () => {
        setIsDivVisible(!isDivVisible);
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    //   const api_key = '';
    const loadjop = async () => {
        laydulieujop();
        setIsDisabled(false);
    };
    function chuyenhuong(data) {
        // Xử lý dữ liệu ở đây
        console.log(data);
        if (data.status == 0 || data.status == "0") {

        }
        else if (data.router == false) {
            setTimeout(function () {
                window.location.href = data.redirects;
            }, 1500);
        }
        else {

        }
    };

    function sadasdasdasdasd(jasdjnlaksdl) {
        axios.get('https://hust.media/jop/telegram/get_jop.php?api_key=' + api_key + '&chedo=' + jasdjnlaksdl, {
            // Đưa dữ liệu của bạn vào đây nếu cần
        })
            .then(response => {
                if (response.data.status != 1 && response.data.error != '') {
                    alert_error(response.data.error);
                    chuyenhuong(response.data);
                }
                else if (response.data.status == 1) {
                    setDatajoptiktok(response.data.datajop);
                    console.log(response.data.datajop);
                    setdatamoney(response.data.money);
                    setidtiktokjop(response.data.idtiktokjop);
                }
                else {
                    alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
                }
            })
            .catch(error => {
                console.error(error);
            });
    };
    const laydulieujop = async () => {
        eventFired = true;
        setIsDisabled(false);
        setDatajoptiktok('');
        const jasdjnlaksdl = 'cheotele';
        sadasdasdasdasd(jasdjnlaksdl);
    }

    function jopapi(urljopapi, itemjop, apidata) {

        console.log(urljopapi);
        const headers = {
            'Content-Type': 'application/json'
        }
        axios.post(urljopapi, apidata, headers)
            .then(response => {

                if (response.data.status != 1 && response.data.error) {
                    alert_error(response.data.error);
                    chuyenhuong(response.data);
                    laydulieujop();
                }
                else if (response.data.status == 1 || response.data.order) {
                    alert_success(response.data.order);
                    laydulieujop();
                }
                else {
                    alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
                }
            })
            .catch(error => {
                alert_error(error);
            });
    }
    const loadjoptiktok = (itemjop) => {
        setdanhap(false);
        const categoryjop = itemjop.category;
        console.log(itemjop.idtiktok);

        eventFired = false;
        const idtiktokchuan = itemjop.idtiktok;
        const apidata = {
            key: api_key,
            service: categoryjop,
            link: idtiktokchuan,
        };
        const urljopapi = "https://hust.media/jop/telegram/checktele.php";
        jopapi(urljopapi, itemjop, apidata);
    }
    const [isDisabled, setIsDisabled] = useState(false);
    const startjop = (event, itemjop) => {
        // setidtiktokchuan(itemjop.idtiktok);
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        else {
            setdanhap(true);
            setIsDisabled(true);
            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    document.removeEventListener('visibilitychange', handleVisibilityChange);
                    loadjoptiktok(itemjop);
                } else {
                    // do something when the tab becomes hidden
                }

            };
            document.addEventListener('visibilitychange', handleVisibilityChange);
            return () => {
            };
        }
    };

    useEffect(() => {
        if (isMobile) {
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android")) {
            } else {
                setadskeeper(true);
            }
        }
        else {
            setadskeeper(true);
        }
        setTimeout(() => {
            const myCookieValue = Cookies.get('apikey');
            console.log(myCookieValue);
            setapi_key(myCookieValue);
        }, 100);
    }, []);
    useEffect(() => {
        // hienads();
        setTimeout(() => {
            const myCookieValue = Cookies.get('apikey');
            if (myCookieValue) {
                if (api_key != '') {
                    laydulieujop();
                }
            }
            else {
                setIsDisabled(true);
                setchuadangnhap(true);
            }
        }, 400);

    }, [api_key]);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        console.log('ádasdasd');
    }
    const ButtonJopTiktok = ({ itemjop, isDisabled }) => {

        return (
            <button className="flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-1 w-full dark:bg-slate-800 dark:text-white">
                <div className="flex items-center justify-between flex-1">
                    <span className="text-lg font-medium text-white mx-auto">
                        {!isDisabled ? (
                            <div>{itemjop.textbutton}</div>
                        ) : (<> {itemjop.textwait ? (
                            <div>  {itemjop.textwait}<PulseLoader color="#fff" size={15} /> </div>) : (<div>  Please wait a moment 😊<PulseLoader color="#fff" size={15} /> </div>)}
                        </>
                        )}
                    </span>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 8.71423C0 8.47852 0.094421 8.25246 0.262491 8.08578C0.430562 7.91911 0.658514 7.82547 0.896201 7.82547H13.9388L8.29808 2.23337C8.12979 2.06648 8.03525 1.84013 8.03525 1.60412C8.03525 1.36811 8.12979 1.14176 8.29808 0.974875C8.46636 0.807989 8.6946 0.714233 8.93259 0.714233C9.17057 0.714233 9.39882 0.807989 9.5671 0.974875L16.7367 8.08499C16.8202 8.16755 16.8864 8.26562 16.9316 8.3736C16.9767 8.48158 17 8.59733 17 8.71423C17 8.83114 16.9767 8.94689 16.9316 9.05487C16.8864 9.16284 16.8202 9.26092 16.7367 9.34348L9.5671 16.4536C9.39882 16.6205 9.17057 16.7142 8.93259 16.7142C8.6946 16.7142 8.46636 16.6205 8.29808 16.4536C8.12979 16.2867 8.03525 16.0604 8.03525 15.8243C8.03525 15.5883 8.12979 15.362 8.29808 15.1951L13.9388 9.603H0.896201C0.658514 9.603 0.430562 9.50936 0.262491 9.34268C0.094421 9.17601 0 8.94995 0 8.71423Z" fill="white"></path></svg>
                </div>
            </button>
        );
    };
    const [showAd, setShowAd] = useState(true);
    const handleCloseAd = () => {
        setShowAd(false);
    };
    return (
        <div>
            < Cheotele />
            <div className="header bg-gradient pb-8 pt-2 pt-md-8" style={{ backgroundColor: '#ffc0cb' }} >
                <AdSense.Google
                    client="ca-pub-4574266110812955"
                    slot="1627514116"
                    style={{ display: 'block', height: 100 }}
                    format=""
                />
                <span className="mask bg-gradient opacity-8" style={{ backgroundColor: '#ffc0cb' }}></span>
                <div className="container-fluid mt-1">
                    <a href={`/shop/orders/media`} style={{ textDecoration: 'none' }} >
                        <div className="card">
                            <button className="btn btn btn-outline-primary "
                                type="button" > Nhận follow tim view miễn phí</button>   </div>
                    </a>
                    <div className="d-flex flex-row bd-highlight mb-2">
                        {location.pathname.includes('/cheotiktok') && <div className="p-2 bd-highlight">
                            <div className="relative inline-block text-left">
                                <button
                                    type="button"
                                    className="inline-flex justify-center  rounded-md border border-pink-300 shadow-sm px-2 py-1 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    id="options-menu"
                                    aria-haspopup="true"
                                    aria-expanded="true"
                                    onClick={toggleDropdown}
                                >
                                    Chuyển acc <br></br>  thêm <br></br> nhiệm vụ
                                    <FaCaretDown className="ml-2 -mr-1 h-5 w-5" />
                                </button>

                                {isOpen && (
                                    <div className="absolute z-10 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                        <div
                                            className="py-1"
                                            role="menu"
                                            aria-orientation="vertical"
                                            aria-labelledby="options-menu"
                                        >
                                            <a
                                                href="https://hust.media/reactapp/converttiktok"
                                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                role="menuitem"
                                            >
                                                Chuyển tài khoản khác làm nhiệm vụ
                                            </a>
                                            <a
                                                href={`/shop/accounts/orders`}
                                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                role="menuitem"
                                            >
                                                Mua clone để chéo tiếp
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>}
                        {location.pathname.includes('/cheotwitter') && <> Chéo twitter</>}
                        {location.pathname.includes('/cheoyt') && <> Chéo Youtube</>}
                    </div>
                    {
                        !datajoptiktok && !chuadangnhap ? (
                            <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">

                                <ClipLoader color="#fff" size={150} />
                            </div>
                        ) :

                            datajoptiktok.length === 0 && location.pathname.includes('/cheotele') && (
                                <>
                                    <h2>Hết nhiệm vụ, vui lòng xem xét làm jop khác hoặc mua sắm để hỗ trợ cộng đồng. 🛍️</h2>
                                </>
                            )}
                    {chuadangnhap ? (<>
                        <div className="z-index-1 position-relative">
                            <a className="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder" href="/">hust.media</a>
                            <p className="opacity-75 text-black">Là một hệ thống trao đổi tương tác một cách tự nhiên và an toàn. Hệ thống hoạt động theo nguyên tắc tự nguyện trao đổi giữa các thành viên, cùng giúp nhau tăng tương tác, tăng hiệu quả bán hàng, truyền thông.<br />#traodoisub , #tangsub, #tuongtaccheo, #tuongtacfb, #tangtheodoimienphi, #tanglikemienphi, #tanglike, #tangtheodoi, #tangcmt, #tangcamxuc, #tangshare, #cayxu, #toolcayxu, #tangview, #tangtiktok, #traodoitiktok, #tiktok </p>
                        </div>
                    </>) : (
                        <>{datajoptiktok && (
                            <>
                                <div className="max-w-2xl px-0 py-0  mx-auto rounded-lg shadow-xl">

                                    {datajoptiktok.map((itemjop) => {
                                        const shouldShowAd = Math.random() < 0.5; // Tạo số ngẫu nhiên và gán giá trị true hoặc false dựa trên số đó
                                        return (
                                            <>
                                                {itemjop.id == 0 ? (<>
                                                    <div className=" mt-1  py-1 h-full" id="table_auto" >
                                                        <span className="text-lg font-medium  mx-auto">


                                                            {!isDisabled && (
                                                                <div>{itemjop.textbutton}</div>
                                                            )}


                                                        </span> </div>
                                                </>) :
                                                    (
                                                        <div className=" mt-1  py-1 h-full" id="table_auto" >
                                                            <div className="card shadow">
                                                                <div className="card-header bg-transparent">
                                                                    <div className="row align-items-center">
                                                                        <div className="col">
                                                                            <h2 className="mb-0 text-base" ><i className="ni ni-shop"></i>
                                                                                {itemjop.idtiktok}
                                                                            </h2>
                                                                            {/* <Copycmtmaps text={ itemjop.comment } /> */}
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div className="card">
                                                                    <a onClick={(event) => startjop(event, itemjop)} data-category={itemjop.category}
                                                                        disabled={isDisabled} style={{ textDecoration: 'none' }}
                                                                        href={itemjop.lienketjop} target="_blank" >
                                                                        <ButtonJopTiktok itemjop={itemjop} isDisabled={isDisabled} />
                                                                    </a>
                                                                    {itemjop.id % 4 === 0 ? <>
                                                                    </> : itemjop.id % 4 === 1 ? <>
                                                                        <iframe
                                                                            data-aa="2271984"
                                                                            src="//ad.a-ads.com/2271984?size=320x50"
                                                                            frameBorder="0"
                                                                            scrolling="no"
                                                                            allowFullScreen
                                                                            style={{
                                                                                width: '320px',
                                                                                height: '50px',
                                                                                border: 0,
                                                                                padding: 0,
                                                                                overflow: 'hidden',
                                                                                backgroundColor: 'transparent'
                                                                            }}
                                                                        ></iframe>
                                                                    </> : itemjop.id % 4 === 2 ? <>
                                                                        <iframe
                                                                            data-aa="2271984"
                                                                            src="//ad.a-ads.com/2271984?size=320x50"
                                                                            frameBorder="0"
                                                                            scrolling="no"
                                                                            allowFullScreen
                                                                            style={{
                                                                                width: '320px',
                                                                                height: '50px',
                                                                                border: 0,
                                                                                padding: 0,
                                                                                overflow: 'hidden',
                                                                                backgroundColor: 'transparent'
                                                                            }}
                                                                        ></iframe>
                                                                    </> : itemjop.id % 4 === 3 ? <>
                                                                        <iframe
                                                                            data-aa="2271984"
                                                                            src="//ad.a-ads.com/2271984?size=320x50"
                                                                            frameBorder="0"
                                                                            scrolling="no"
                                                                            allowFullScreen
                                                                            style={{
                                                                                width: '320px',
                                                                                height: '50px',
                                                                                border: 0,
                                                                                padding: 0,
                                                                                overflow: 'hidden',
                                                                                backgroundColor: 'transparent'
                                                                            }}
                                                                        ></iframe></> : <></>}
                                                                    <p className="my-0">
                                                                        {itemjop.category == 'pro' && (itemjop.chedo == 'tiktoklike' || itemjop.chedo == 'tiktokfol') ? (<>    Nhân 2 giá trị nhận Coins
                                                                        </>
                                                                        ) : itemjop.category == 'follow' && idtiktokjop ? (
                                                                            <>ko đúng @{idtiktokjop} sẽ ko nhận dc Coins  </>
                                                                        ) : (<></>
                                                                        )}   </p>
                                                                </div>
                                                            </div>

                                                        </div>)} </>);
                                    })}
                                </div> </>)}</>)}


                    <br></br>
                    <Outlet />
                    <div className="flex">
                        <button type="button" className="btn btn-outline-primary" onClick={loadjop}>Tải lại danh sách     </button>

                        <a href='/' >
                            <button type="button" className="btn btn-outline-primary" >
                                Quay về trang chủ
                            </button>
                        </a>
                        {danhap && <>
                            <button type="button" className="btn btn-outline-primary" onClick={loadjoptiktok}>Check   </button>
                        </>}
                        <div id="right" className="position-absolute end-0 mr-2">
                            <div className="card-profile-image">
                                <span className=" rounded-pill bg-green-500"   >
                                    &nbsp;       <span className="text-lg font-weight-bold mb-3" style={{ color: 'white' }} >
                                        {datamoney}  </span>
                                    &nbsp;
                                </span>
                            </div>  </div>
                    </div>
                </div>

                <div style={{ textAlign: "center" }} className=" items-center justify-center">
                    {
                        showadskeeper &&
                        (
                            <>
                                <div id="M882924ScriptRootC1520508"></div>
                            </>
                        )
                    }
                    <div id="hustmedia"></div>
                    <Helmet>
                        <script src='https://hust.media/api/website/main.js?v=4&chedo=2'></script>
                    </Helmet>

                    {isDivVisible && (
                        <>
                            {/* <p className="mb-0 text-sm" onClick={handleToggle}>Tắt quảng cáo </p> */}
                            <Helmet>
                                <script src="https://www.vipads.live/vn/9F1A9524-FED9-727-33-94E406C649F0.blpha"></script>
                                <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>

                            </Helmet>
                        </>
                    )}
                </div>
            </div>    </div>
    );
}


export default Jop;
